import React from 'react';
import { ArrowRight, Calendar } from 'lucide-react';
import CodeCard from './CodeCard';
import { brand } from '../mock';

const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0 grid-bg pointer-events-none" />
      <div className="absolute inset-0 hero-glow pointer-events-none" />

      <div className="relative mx-auto max-w-6xl px-5 pt-16 md:pt-24 pb-24 md:pb-32">
        <div className="text-center fade-up">
          <h1 className="serif-display text-[44px] leading-[1.05] sm:text-6xl md:text-7xl lg:text-[88px] text-ink">
            Turn AI Into Your Unfair
            <br />
            <span className="italic text-[#C2603A]">_Advantage</span>
          </h1>

          <div className="mx-auto mt-8 h-[3px] w-16 rounded-full bg-[#C2603A]/80" />

          <p className="mx-auto mt-8 max-w-2xl text-[17px] md:text-[18px] leading-relaxed text-muted">
            We build custom AI agents, automations, and strategies that save your
            business 10+ hours per week. From concept to deployment, we handle
            everything.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#contact"
              className="btn-primary inline-flex items-center gap-2 rounded-xl px-5 py-3 text-[15px] font-medium"
            >
              Book a Consultation <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="#services"
              className="btn-outline inline-flex items-center gap-2 rounded-xl px-5 py-3 text-[15px] font-medium"
            >
              See Our Services
            </a>
          </div>
        </div>

        <div className="mt-16 md:mt-20 relative">
          <CodeCard />
        </div>
      </div>
    </section>
  );
};

export default Hero;
